import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { ChartPie } from 'common/charts';
import { fetchCasesReports } from 'actions/Report/Case';
import _ from 'lodash';

export default class CasesBySource extends Component {
  constructor(props) {
    super(props);
    this.fetchData = this.fetchData.bind(this);
    this.state = {
      casesBySource: [],
      title: '',
    };
  }

  componentDidMount() {
    this.fetchData(this.props.filters);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!_.isEqual(this.props.filters, nextProps.filters)) {
      this.fetchData(nextProps.filters);
    }
  }

  fetchData(filters) {
    const { scope, id } = this.props;
    fetchCasesReports(scope, id, 'by-source', filters)
      .then((response) => {
        this.setState({
          casesBySource: _.orderBy(_.get(response, 'data.values', []), 'title', 'asc'),
          title: _.get(response, 'data.title', ''),
        });
        this.props.loaded('casesBySource');
      });
  }

  render() {
    if (_.isEmpty(this.state.casesBySource)) {
      return null;
    }
    return (
      <ChartPie
        data={this.state.casesBySource}
        title={this.state.title}
        x={(d) => d.title}
        y={(d) => d.total}
        style={{ height: '350px' }}
        valueFormat="d"
        twoColsLegend={false}
        colors={[
          '#FF9900',
          '#E8E879',
          '#7ED1A3',
        ]}
      />
    );
  }
}

CasesBySource.propTypes = {
  filters: PropTypes.shape({
    end_date: PropTypes.string,
    network_ids: PropTypes.array,
    start_date: PropTypes.string,
  }),
  loaded: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  scope: PropTypes.string.isRequired,
};
